<template>
    <div class="mMobileCampaign-container" v-observe-visibility="startAnimate">
        <div class="mMobileVideo">
            <div id="playermobile"></div>
        </div>
        <div class="mMobileIgPictures">
            <p class="mMobilecampignText" :class="{animate: animate}">#TECATECEROCERO</p>
            <p class="mMobilecampignText2" :class="{animate: animate}">Tus mejores momentos disfrutando del sabor</p>
            <div class="mMobilecampign-Pictures">
                <div class="mMobileRow-Pictures">
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo1" alt="Necesitas 0.0 cero pretextos para disfrutar de tus planes con amigos con la nueva TECATE 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo2" alt="Necesitas 0.0 cero pretextos para disfrutar el refrescante liquido de la nueva TECATE 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                </div>
                <div class="mMobileRow-Pictures">
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo3" alt="Necesitas 0.0 pretextos para comer tu comida callejera favorita con la NUEVA Tecate 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo4" alt="Necesitas 0.0 pretextos para disfrutar la NUEVA Tecate 0.0 bien fría" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                </div>
                <div class="mMobileRow-Pictures">
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo5" alt="Necesitas 0.0 pretextos para disfrutar la NUEVA Tecate 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo6" alt="Necesitas 0.0 pretextos para disfrutar de tus antojitos favoritos con la NUEVA Tecate 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                </div>
                <div class="mMobileRow-Pictures">
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo7" alt="Necesitas 0.0 pretextos para disfrutar la NUEVA Tecate 0.0 bien fría" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo8" alt="Necesitas 0.0 pretextos para disfrutar la NUEVA Tecate 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                </div>
                <div class="mMobileRow-Pictures">
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo9" alt="Necesitas 0.0 pretextos para disfrutar de tus antojitos favoritos con la NUEVA Tecate 0.0" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                    <a href="" target="_blank" class="Mobileimg-mRow1" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'home')">
                        <img :src="photo10" alt="photo10" />
                        <div class="Mobileicon-instagram">
                            <img class="Mobilephoto" :src="instagram" alt="Instagram">
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import photo1 from '@/assets/tkt-campaign/photo1.png';
import photo2 from '@/assets/tkt-campaign/photo2.png';
import photo3 from '@/assets/tkt-campaign/photo3.png';
import photo4 from '@/assets/tkt-campaign/photo4.png';
import photo5 from '@/assets/tkt-campaign/photo5.png';
import photo6 from '@/assets/tkt-campaign/photo6.png';
import photo7 from '@/assets/tkt-campaign/photo7.png';
import photo8 from '@/assets/tkt-campaign/photo8.png';
import photo9 from '@/assets/tkt-campaign/photo9.png';
import photo10 from '@/assets/tkt-campaign/photo10.png';
import instagram from "@/assets/redes-sociales/INSTAGRAM.png";
import tagFunctions from '@/utils/tagFunctions.js';
import YouTubePlayer from 'youtube-player';
import { mapGetters } from "vuex";
import Bowser from "bowser";

let timer, percent = 0, quartileTime, duration

export default {
    name: "Elaboration",
    data() {
        return {
            animate: false,
            isSafari: false,
            photo1,
            photo2,
            photo3,
            photo4,
            photo5,
            photo6,
            photo7,
            photo8,
            photo9,
            photo10,
            instagram,
            playermobile: null,
        }
    },

    computed: {
        ...mapGetters(["isLoaded"]),
    },

    methods: {
        startAnimate(isVisible) {
            if (isVisible) {
                this.animate = true
            }
        },

        socialClick(socialNetwork, action) {
            tagFunctions.evSocialNetworkPush(socialNetwork, action)
            pintrk('track', 'custom', {property: socialNetwork});
        },
        socialGA4Click(action, element, section) {
            tagFunctions.user_interactionPush(action, element, section)
        },

        record(event) {
            let currentTime = Math.round(event.target.getCurrentTime());
            percent = getPercent(event);
            if (currentTime == quartileTime) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "25",
                duration
                );
            }
            if (currentTime == 2 * quartileTime) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "50",
                duration
                );
            }
            if (currentTime == 3 * quartileTime) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "75",
                duration
                );
            }
            if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
                tagFunctions.evVideoPush(
                event.target.getVideoData().title,
                "Reach",
                "100",
                duration
                );
            }
            function getPercent(event) {
                return Math.round(
                    (event.target.getCurrentTime() / event.target.getDuration()) * 100
                );
            }
        },

        onPlayerStateChange(event) {
            duration = event.target.getDuration();
            quartileTime = Math.round(event.target.getDuration() / 4);
            const getQuartile = () => {
                if (percent <= 25) return 25;
                else if (percent > 25 && percent <= 50) return 50;
                else if (percent > 50 && percent <= 75) return 75;
                else return 100;
            };
            if (event.data == window.YT.PlayerState.PLAYING) {
                tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile(), duration)
                tagFunctions.user_interactionPush('click', 'play :: #TecateCeroCero | 0.0 ALCOHOL, 0.0 PRETEXTOS', 'home')
                timer = setInterval(() => {
                    this.record(event);
                }, 1000);
            } else {
                clearInterval(timer);
            }
            if (event.data == window.YT.PlayerState.ENDED) {
                tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile(), duration)
                tagFunctions.user_interactionPush('click', 'complete :: #TecateCeroCero | 0.0 ALCOHOL, 0.0 PRETEXTOS', 'home')
            }
            if (event.data == window.YT.PlayerState.PAUSED) {
                tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile(), duration)
                tagFunctions.user_interactionPush('click', 'pause :: #TecateCeroCero | 0.0 ALCOHOL, 0.0 PRETEXTOS', 'home')
            }
        },
    },

    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName() == 'Safari') {
            this.isSafari = true
        }
    },

    mounted() {
        this.playermobile = YouTubePlayer('playermobile', { videoId: 'OrSWYcp1Nnk', width: '100%', height: '100%' })
        this.playermobile.on('stateChange', this.onPlayerStateChange)
    },
}

</script>

<style  scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileCampaign.scss";
</style>